import { Lead } from '@tassomutuo-backoffice/types';
import useLeadActionRequired, {
  ActionRequiredType,
} from './useLeadActionRequired';

const useLeadsFilterAndOrder = () => {
  const { renderActionRequired } = useLeadActionRequired();

  const orderLeadByActionRequired = (leads: Lead[]) => {
    console.log('Ordering leads by action required', leads);
    const order = {
      appointmentToBeRescheduled: 1,
      appointmentToBeConfirmed: 2,
      appointmentHasPassed: 3,
      oldUpdate: 4,
    };

    const orderedLeads = leads.sort((a, b) => {
      const actionRequiredA = renderActionRequired(
        { lead: a },
        true
      ) as ActionRequiredType;
      const actionRequiredB = renderActionRequired(
        { lead: b },
        true
      ) as ActionRequiredType;

      // Gestisci il caso in cui actionRequired è null
      const orderA = actionRequiredA ? order[actionRequiredA] : Infinity;
      const orderB = actionRequiredB ? order[actionRequiredB] : Infinity;

      return orderA - orderB;
    });

    // Dividi le lead con action required da quelle senza
    const leadsWithActionRequired = orderedLeads.filter(
      (lead) => renderActionRequired({ lead }, true) !== null
    );
    const leadsWithoutActionRequired = orderedLeads.filter(
      (lead) => renderActionRequired({ lead }, true) === null
    );

    // Restituisci la lista ordinata con lead con action required seguite da quelle senza
    return leadsWithActionRequired.concat(leadsWithoutActionRequired);
  };

  return { orderLeadByActionRequired };
};

export default useLeadsFilterAndOrder;
